import { render, staticRenderFns } from "./step-cost-vin.vue?vue&type=template&id=170dd0ac"
import script from "./step-cost-vin.vue?vue&type=script&lang=ts"
export * from "./step-cost-vin.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports